<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h2>{{ title }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
      >
        <v-row v-for="(item) in items" :key="item">
          <v-col
            cols="12">
              <v-select
                v-model="localItem[`${item}`]"
                :items="['Yes', 'No']"
                :label="$t(`InLineQualityCheck.FormInLineQualityCheck.${item}`)"
              ></v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'InlineQualityCheckSampleItems',
  props: {
    /**
     * Holds the title value, with a default of ''
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Holds the items value, with a default of []
     */
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * Holds the sizeRange value, with a default of ''
     */
    sizeRange: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localItem: {},
    };
  },
  computed: {
    /**
     * Returns the cols property
     */
    cols() {
      return Math.round(12 / (this.size + 1));
    },
  },
};
</script>
